export default __webpack_public_path__ + "static/media/image1.5bbf6561.png";